import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

interface Breadcrumb {
  label: string;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this.breadcrumbs.asObservable();

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const root = this.router.routerState.snapshot.root;
        const breadcrumbs = this.createBreadcrumbs(root);
        this.breadcrumbs.next(breadcrumbs);
      });
  }

  private createBreadcrumbs(
    route: ActivatedRouteSnapshot,
    url: string = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const routeConfig = route.routeConfig;
  
    // Handle dynamic segments in the path
    let path = routeConfig?.path || ''; // Default to empty string if path is not defined
    const routeParams = route.params;
  
    // Replace any dynamic segments (e.g., :id) with their actual values from route params
    Object.keys(routeParams).forEach((key) => {
      path = path.replace(`:${key}`, routeParams[key]);
    });
  
    // Append this route's path to the overall URL
    const nextUrl = path ? `${url}/${path}` : url;
  
    // Add breadcrumb if there's a 'breadcrumb' data property
    if (routeConfig?.data?.['breadcrumb']) {
      const breadcrumb: Breadcrumb = {
        label: routeConfig.data['breadcrumb'],
        url: nextUrl,
      };
      breadcrumbs.push(breadcrumb);
    }
  
    // If there is a child route, continue building the breadcrumbs
    if (route.firstChild) {
      return this.createBreadcrumbs(route.firstChild, nextUrl, breadcrumbs);
    }
  
    return breadcrumbs;
  }
  
}
